import React, { useState } from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ButtonConsensus } from 'components';
import { colors } from 'utils/colorsSteps';

const ModalRemovePjeFlag = props => {
  const { open, onClose, confirm, refreshData } = props;

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    await confirm();
    setLoading(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={'sm'}
      >
        <DialogTitle>
          <Typography variant="h5">Não é possível excluir a movimentação</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h5">
            Essa movimentação não pode ser excluída pois há uma tentiva falha de integração com o
            PJE associada a ela. Entretanto, ela pode ser alterada para não mais integrar
            automaticamente com o PJE. Você deseja realizar essa alteração?
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonConsensus
            title="Cancelar"
            backgroundColor="#fff"
            hovercolor={colors.greySecundary}
            color={colors.greyShadow}
            onClick={onClose}
          />
          <ButtonConsensus
            title="Confirmar"
            backgroundColor={colors.primary}
            hovercolor={colors.primary}
            onClick={handleSave}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalRemovePjeFlag;
